module.exports = __webpack_public_path__ + "img/water-droplet-3.c10c3cd6.png";